export { default } from './Pagination';



// WEBPACK FOOTER //
// ./src/index.js